import React, { Component } from "react";
import firebase from "firebase";
import Helmet from "react-helmet";
import { StyleSheet, css } from "aphrodite";
import { browserHistory } from "react-router";
import "./App.css";

class App extends Component {
  unsubscribe = null;
  componentDidMount() {
    this.unsubscribe = firebase.auth().onAuthStateChanged(user => {
      let userCheck = user;
      if (!userCheck) {
        this._redirect();
        this.unsubscribe();
      }
    });
  }

  _redirect() {
    browserHistory.push("/");
  }

  render() {
    return (
      <div className={"container"}>
        <Helmet>
          <title>TuPicNow - Admin</title>
        </Helmet>
      
        {this.props.children}
        <footer className={css(styles.footer)}>Copyright © 2017 PicNow</footer>
      </div>
    );
  }
}

export default App;

const styles = StyleSheet.create({
  root: {
    maxWidth: 1000,
    color: "#000",
    margin: "2rem auto",
    padding: "0 1rem"
  },
  title: {
    color: "#000",
    maxWidth: 300,
    fontWeight: "bold",
    fontSize: 56
  },
  footer: {
    margin: "4rem auto",
    textAlign: "center",
    color: "#b7b7b7"
  },
  footerLink: {
    display: "inline-block",
    color: "#000",
    textDecoration: "none"
  }
});



// WEBPACK FOOTER //
// /src/containers/App/App.js